import { styled, GreenGradient } from '@mybonus/ui';

export const $GreenGradient = styled(GreenGradient)`
	flex-direction: row;
	align-items: center;
	display: flex;
	justify-content: space-between;
	padding: ${({ theme }) => theme.space.md}px;
`;
